import ApartmentIcon from "@mui/icons-material/Apartment";
import ReplayIcon from "@mui/icons-material/Replay";
import { Box, Typography } from "@mui/material";
import { useSetBreadcrumbs } from "code/setBreadcrumbsHelper";
import { LISTING_PAGE_LEVEL } from "constants/BreadcrumbLevel";

export default function AccessPendingApprovalPage() {
	useSetBreadcrumbs("Access Pending", LISTING_PAGE_LEVEL);

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				textAlign: "center",
				flexGrow: 1,
				my: { xs: 4, md: 10 },
				px: 2
			}}
		>
			<Box sx={{ position: "relative", color: "secondary.light50", lineHeight: 0, mb: 4 }}>
				<ApartmentIcon sx={{ fontSize: 175 }} />
				<ReplayIcon
					sx={{
						fontSize: 92,
						position: "absolute",
						top: -4,
						right: -20,
						bgcolor: "background.default",
						borderRadius: "50%",
						transform: "scaleX(-1)"
					}}
				/>
			</Box>

			<Typography variant="display4" component="h1" sx={{ mb: 1.5 }}>
				Your access is pending approval
			</Typography>

			<Typography variant="text16" sx={{ maxWidth: 445, mb: 1.5 }}>
				Your access request has been sent to your company administrator and is awaiting approval.
				<br />
				Once approved, you&rsquo;ll be able to access bookings and account features for this
				account.
			</Typography>
		</Box>
	);
}
